import { BaseResponseMapper } from './Base'
import { Pagination } from '@/domain/entities/Pagination'
import { User, UserData, Export, Import } from '@/domain/entities/User'
import { AxiosResponse } from 'axios'

export class UserDataMapper extends BaseResponseMapper {
  public convertUserListFromApi(result: AxiosResponse<any>): User {
    const { data } = result
    return new User(
      data.success,
      data.message,
      new Pagination(
        data.pagination.current_page,
        data.pagination.page_count,
        data.pagination.page_size,
        data.pagination.row_count,
        data.pagination.first_row_on_page,
        data.pagination.last_row_on_page
      ),
      data.data.map(
        (val) =>
          new UserData(
            val.id,
            val.photo,
            val.photowithouturl,
            val.from,
            val.phone,
            val.email,
            val.is_active,
            val.is_login,
            val.last_login,
            val.last_access,
            val.is_registered,
            val.from,
            val.salesman,
            val.grade,
            val.created_at
          )
      )
    )
  }
  public convertExportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Export(data.success, data.message, data.data)
  }
  public convertImportFileFromAPi(result: AxiosResponse<any>): Export {
    const { data } = result
    return new Import(data.success, data.message, data.fileName, data.fileByte)
  }
}
